import {
  Component,
  HostBinding,
  HostListener,
  Injector,
  OnDestroy,
  OnInit,
  SkipSelf,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';

import { Subscription } from 'rxjs/Subscription';

import { ModalService } from './modal.service';

export enum ModalSize {
  SMALL = 'small',
  MID = 'mid',
  LARGE = 'large',
}

@Component({
  selector: 'fl-modal',
  template: `
    <div class="ModalContainer"
      (click)="$event.stopPropagation()"
      [ngClass]="{
        SmallSize: size === 'small',
        MidSize: size === 'mid',
        LargeSize: size === 'large'
      }"
    >
      <ng-container #modalContent></ng-container>
    </div>
  `,
  styleUrls: ['./modal.component.scss'],
})
export class ModalComponent implements OnInit, OnDestroy {
  @ViewChild('modalContent', { read: ViewContainerRef })
  modalContent: ViewContainerRef;
  @HostBinding('class.BackdropActive') backdropActive = false;

  // To be set by modal service at `open`
  size = ModalSize.LARGE;
  hideCloseButton = false;

  openStreamSubscription: Subscription;

  constructor(
    private modalService: ModalService,
    @SkipSelf() private injector: Injector,
  ) {}

  ngOnInit() {
    this.modalService.setContainer(this.modalContent, this.injector, this);
    this.openStreamSubscription = this.modalService.openStream.subscribe(
      open => {
        this.backdropActive = !!open;
      },
    );
  }

  ngOnDestroy() {
    this.openStreamSubscription.unsubscribe();
  }

  @HostListener('click')
  handleClick() {
    this.modalService.close();
  }

  @HostListener('document:keydown.escape', ['$event'])
  handleEscape(e: KeyboardEvent) {
    this.modalService.close();
  }
}



// WEBPACK FOOTER //
// ./src/@freelancer/ui/modal/modal.component.ts